module.exports = __webpack_public_path__ + "static/img/10commitments_6.8941795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_6.jpg
// module id = oCjv
// module chunks = 0